import { jsx as _jsx } from "react/jsx-runtime";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
const { vendors: { GET_STORES, SEARCH_STORES } } = queries;
const { vendors: { DELETE_STORE } } = mutations;
const StoresList = () => (_jsx(List, { deleteMutation: DELETE_STORE, hasSearch: true, itemNamePlural: "stores", label: "Stores", listQuery: GET_STORES, listQueryDataName: "getStores", pathPrefix: "/vendors", searchQuery: SEARCH_STORES, searchQueryDataName: "searchStores", searchQueryInputName: "searchStoresInput", searchQueryPropertyName: "url" }));
export default StoresList;
